






































































import {Component} from 'vue-property-decorator'
import MyWalletOrbitCards from '@/components/myWallet/MyWalletOrbitCards.vue'
import MyWalletOrbitTableContent from '@/components/myWallet/MyWalletOrbitTableContent.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'
import LastPriceUpdated from '@/components/LastPriceUpdated.vue'
import PoweredBy, {PoweredByItem} from '@/components/PoweredBy.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitTransactionCollection} from '@/model/collection/OrbitTransactionCollection'
import moment from 'moment'
import {$} from '@/facade'

@Component({
  components: {
    MyWalletOrbitTableContent,
    MyWalletOrbitCards,
    LastPriceUpdated,
    PoweredBy,
  },
})
export default class MyWalletOrbitOverview extends MixinScreenSize {
  lastRound = 0
  activeRound = 0
  hasRound = false
  lastTimeUpdated = ''
  cardsRefreshKey = 0

  orbitTransactionCollection = new OrbitTransactionCollection()

  poweredByList: PoweredByItem[] = [
    {
      url: `https://ndapp.org/orbit`,
      alt: 'orbit icon',
      filename: 'orbit-logo.png',
    },
  ]

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    this.$await.init('populateOrbitProjects')

    this.activeRound = Number(await OrbitHelper.getActiveRound()) || 0
    this.lastRound = Number(await OrbitHelper.getLastRound()) || 0

    // FALLBACK: First time we populate the resources, we don't have a round yet
    if (this.activeRound === 0 && this.lastRound === 0) {
      this.hasRound = false
    } else {
      this.hasRound = true
    }

    await this.populateLastTimeUpdated()

    this.$await.done('populateOrbitProjects')
  }

  async populateLastTimeUpdated() {
    const lastTransactionCollection = new OrbitTransactionCollection()

    lastTransactionCollection.orderBy = 'updatedAt'
    lastTransactionCollection.asc = false
    lastTransactionCollection.limit = 1

    await lastTransactionCollection.queryAsPage()

    if (
      lastTransactionCollection.items.length > 0 &&
      lastTransactionCollection.items[0].updatedAt
    ) {
      const updatedAt = lastTransactionCollection.items[0].updatedAt
      const date = moment.utc(updatedAt)

      this.lastTimeUpdated = date.format(
        $.translate('dateFormat.datetimeAlmostFull') as string
      )
      return
    }

    this.lastTimeUpdated = 'N/A'
  }

  async handleClaimFinished() {
    this.cardsRefreshKey += 1
    await this.populateLastTimeUpdated()
  }
}
